export default __webpack_public_path__ + "static/media/img (3).67a756ca.jpg";